module.exports = __webpack_public_path__ + "static/media/1Well_Leased.6ac58cfe.svg";